import { LucidePersonStanding } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login");
  }, []);
  
  return (
    <LucidePersonStanding />
  )

};

export default LandingPage;